/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_NotificationsInputs */

const id_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi`)
};

const ms_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan`)
};

const da_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikationer`)
};

const de_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

const en_us2_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const es_es2_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const es_mx2_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const fil_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Notipikasyon`)
};

const fr_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const it_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche`)
};

const hu_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesítések`)
};

const nl_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen`)
};

const no_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varsler`)
};

const pl_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia`)
};

const pt_br2_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const pt_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const ro_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificări`)
};

const fi_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitukset`)
};

const sv_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiser`)
};

const vi_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo`)
};

const tr_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler`)
};

const cs_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznámení`)
};

const bg_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Известия`)
};

const ru_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления`)
};

const uk_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення`)
};

const ar_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات`)
};

const hi_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ`)
};

const th_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือน`)
};

const ja_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const zh_cn2_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const zh_hant1_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const ko_footer_notifications = /** @type {(inputs: Footer_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Footer_NotificationsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_notifications = /** @type {((inputs?: Footer_NotificationsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_NotificationsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_notifications(inputs)
	if (locale === "ms") return ms_footer_notifications(inputs)
	if (locale === "da") return da_footer_notifications(inputs)
	if (locale === "de") return de_footer_notifications(inputs)
	if (locale === "en-US") return en_us2_footer_notifications(inputs)
	if (locale === "es-ES") return es_es2_footer_notifications(inputs)
	if (locale === "es-MX") return es_mx2_footer_notifications(inputs)
	if (locale === "fil") return fil_footer_notifications(inputs)
	if (locale === "fr") return fr_footer_notifications(inputs)
	if (locale === "it") return it_footer_notifications(inputs)
	if (locale === "hu") return hu_footer_notifications(inputs)
	if (locale === "nl") return nl_footer_notifications(inputs)
	if (locale === "no") return no_footer_notifications(inputs)
	if (locale === "pl") return pl_footer_notifications(inputs)
	if (locale === "pt-BR") return pt_br2_footer_notifications(inputs)
	if (locale === "pt") return pt_footer_notifications(inputs)
	if (locale === "ro") return ro_footer_notifications(inputs)
	if (locale === "fi") return fi_footer_notifications(inputs)
	if (locale === "sv") return sv_footer_notifications(inputs)
	if (locale === "vi") return vi_footer_notifications(inputs)
	if (locale === "tr") return tr_footer_notifications(inputs)
	if (locale === "cs") return cs_footer_notifications(inputs)
	if (locale === "bg") return bg_footer_notifications(inputs)
	if (locale === "ru") return ru_footer_notifications(inputs)
	if (locale === "uk") return uk_footer_notifications(inputs)
	if (locale === "ar") return ar_footer_notifications(inputs)
	if (locale === "hi") return hi_footer_notifications(inputs)
	if (locale === "th") return th_footer_notifications(inputs)
	if (locale === "ja") return ja_footer_notifications(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_notifications(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_notifications(inputs)
	return ko_footer_notifications(inputs)
});
export { footer_notifications as "footer.notifications" }